<div style="max-width: fit-content; margin-left: auto; margin-right: auto;">
    <div style="width: 800px;">
        <mat-card appearance="outlined">
            <mat-card-title style="margin: 15px; text-align: center;">
                Change your password
            </mat-card-title>
            <mat-card-content style="margin-top: 20px;">
                <app-banner-alert></app-banner-alert>
                <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
                    <div>
                        <mat-form-field appearance="outline" style="width: 100%;">
                            <mat-label>Current Password</mat-label>
                            <input matInput [type]="hideCurrentPassword ? 'password' : 'text'"
                                formControlName="currentPassword" autocomplete="new-password" autocorrect="off"
                                spellcheck="false" (copy)="false" (cut)="false" (paste)="false">
                            <button mat-icon-button matSuffix (click)="hideCurrentPassword = !hideCurrentPassword">
                                <mat-icon>{{ hideCurrentPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                            </button>
                            <mat-error *ngIf="currentPassword?.invalid && currentPassword?.touched">
                                Current Password is required
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div style="text-align: center;">
                        <div *ngIf="newPassword?.value && newPassword?.touched" [ngStyle]="{ 'color': passwordStrengthColor }" style="text-align: center;">
                            Password Strength: {{ passwordStrength }}
                        </div>
                    </div>

                    <div style="margin-top: 20px;">
                        <mat-form-field appearance="outline" style="width: 45%; margin-right: 5%;">
                            <mat-label>New Password</mat-label>
                            <input matInput [type]="hideNewPassword ? 'password' : 'text'" formControlName="newPassword"
                                maxlength="12" minlength="8" autocomplete="new-Password" autocorrect="off" spellcheck="false"
                                (copy)="false" (cut)="false" (paste)="false">
                            <button mat-icon-button matSuffix (click)="hideNewPassword = !hideNewPassword">
                                <mat-icon>{{ hideNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                            </button>
                            <mat-error *ngIf="newPassword?.hasError('required') && newPassword?.touched">
                                New Password is required
                            </mat-error>
                            <mat-error *ngIf="newPassword?.hasError('minlength') && newPassword?.touched">
                                Password should be minimum 8 characters
                            </mat-error>
                            <mat-error *ngIf="newPassword?.hasError('maxlength') && newPassword?.touched">
                                Password must not exceed 12 characters
                            </mat-error>
                            <mat-error *ngIf="newPassword?.hasError('passwordComplexity') && newPassword?.touched">
                                Password must contain at least 1 uppercase letter, 1 lowercase letter, 1 digit, and 1
                                special character
                            </mat-error>
                            <mat-error
                                *ngIf="newPassword?.hasError('containsUsernameSubstring') && newPassword?.touched">
                                Password should not contain username
                            </mat-error>
                            <mat-error *ngIf="newPassword?.hasError('passwordSameAsCurrent') && newPassword?.touched">
                                New Password cannot be the same as Current Password
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline" style="width: 45%; margin-left: 5%;">
                            <mat-label>Re-enter New Password</mat-label>
                            <input matInput [type]="hideReenterPassword ? 'password' : 'text'"
                                formControlName="reenterPassword" autocomplete="new-repassword" autocorrect="off"
                                maxlength="12" minlength="8" spellcheck="false" (copy)="false" (cut)="false" (paste)="false">
                            <button mat-icon-button matSuffix (click)="hideReenterPassword = !hideReenterPassword">
                                <mat-icon>{{ hideReenterPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                            </button>
                            <mat-error *ngIf="reenterPassword?.hasError('required') && reenterPassword?.touched">
                                Re-entering the password is required
                            </mat-error>
                            <mat-error
                                *ngIf="changePasswordForm.hasError('passwordsMismatch') && reenterPassword?.touched">
                                Passwords do not match
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div style="text-align: center; margin-top: 60px;">
                        <button mat-stroked-button (click)="backToHome()" style="margin-right: 10px;">Back</button>
                        <button mat-flat-button color="primary" type="submit"
                            [disabled]="changePasswordForm.invalid">Change Password</button>
                    </div>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>